// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Leaflet from "leaflet";
import * as LocationBoundsHelper from "../helper/LocationBoundsHelper.bs.js";

function getMarkerLocation($$location) {
  if ($$location.TAG === /* WithTime */0) {
    return $$location._0.point;
  } else {
    return $$location._0;
  }
}

function getRouteLatLngArray(routes) {
  if (routes !== undefined) {
    return $$Array.map((function (a) {
                  return a.point;
                }), routes.line);
  } else {
    return [];
  }
}

function getWaypointsLatLngArray(waypoints) {
  if (waypoints !== undefined) {
    return $$Array.map((function (a) {
                  return getMarkerLocation(a.location);
                }), waypoints);
  } else {
    return [];
  }
}

function getBounds(order_detail) {
  var markerLocs = LocationBoundsHelper.getLocationBounds(order_detail);
  return Leaflet.latLngBounds(markerLocs.map(function (loc) {
                  return {
                          lat: loc.lat,
                          lng: loc.lng
                        };
                }));
}

export {
  getMarkerLocation ,
  getRouteLatLngArray ,
  getWaypointsLatLngArray ,
  getBounds ,
  
}
/* leaflet Not a pure module */
